module.exports = __webpack_public_path__ + "static/media/share.3e701fc9.svg";